import { latestAddresses } from '@/mocks/nav';

const statusTone = 'text-primary-700 bg-primary-100 border-primary-200';

export default function LatestAddress() {
  const big = latestAddresses.find((item) => item.size === 'large');
  const smalls = latestAddresses.filter((item) => item.size === 'small');

  return (
    <section id="latest" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-content mx-auto px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="font-label text-xs tracking-[0.28em] text-primary-600">LATEST ADDRESS</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              最新可用地址，全部检测通过
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              主入口优先，其余线路按需备选。点击卡片右侧箭头即可尝试打开，遇到打不开时依次往下试。
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs font-label text-foreground-500">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-soft"></span>
            刚刚完成一轮检测
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2 gap-4 md:gap-5">
          {big && (
            <article className="lg:col-span-2 lg:row-span-2 rounded-lg overflow-hidden bg-background-100 border border-background-200/70 flex flex-col group">
              <div className="relative w-full h-56 md:h-64 lg:h-72 overflow-hidden">
                <img
                  src={big.cover}
                  alt={`${big.name} 最新可用入口`}
                  title={`${big.name} 51网址导航最新地址`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <span className={`absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-label border ${statusTone}`}>
                  <i className="ri-flashlight-fill"></i>
                  {big.tag}
                </span>
              </div>
              <div className="p-6 md:p-7 flex flex-col flex-1">
                <div className="flex items-center justify-between gap-3">
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{big.name}</h3>
                  <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-700">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                    {big.status}
                  </span>
                </div>
                <p className="mt-1 font-label text-sm text-foreground-500">{big.host}</p>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600 flex-1">{big.desc}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {big.features.map((f) => (
                    <span key={f} className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label">
                      {f}
                    </span>
                  ))}
                </div>
                <div className="mt-6 flex items-center justify-between pt-5 border-t border-background-200/70">
                  <div className="flex items-center gap-4 text-xs font-label text-foreground-500">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-speed-up-line"></i>
                      {big.latency}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-time-line"></i>
                      {big.updated}
                    </span>
                  </div>
                  <a
                    href="#latest"
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
                    aria-label={`打开${big.name}`}
                  >
                    <i className="ri-arrow-right-up-line text-lg"></i>
                  </a>
                </div>
              </div>
            </article>
          )}

          {smalls.map((item) => (
            <article
              key={item.id}
              className="rounded-lg overflow-hidden bg-background-50 border border-background-200/70 flex flex-col group hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-28 overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.name} 备用入口`}
                  title={`${item.name} 51导航地址`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <span className={`absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[11px] font-label border ${statusTone}`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-950">{item.name}</h3>
                <p className="mt-0.5 font-label text-xs text-foreground-500">{item.host}</p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 flex-1">{item.desc}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-[11px] font-label text-foreground-500 inline-flex items-center gap-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                    {item.status} · {item.latency}
                  </span>
                  <a
                    href="#latest"
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                    aria-label={`打开${item.name}`}
                  >
                    <i className="ri-arrow-right-up-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}